import { styled } from 'stitches.config'

export const AlignedListRoot = styled('div', {
  width: '100%',
})

export const AlignedListElementContainer = styled('div', {
  width: '100%',
 borderBottom: '1px solid $accent-black',
  '&:first-child': {
   borderTop: '3px solid $accent-black',
  },
  '&:last-child': {
   borderBottom: '3px solid $accent-black',
  },
})
